import LocalizedStrings from 'react-localization';
let clone = require("clone")

var en = {
    // Interface strings
    rafterEmptyWidth: "'Width (mm)' must have a value",
    rafterWarn: "Rafter length must be longer than ",
    rafterWarnGeneric: "Rafter length is to low",
    rafterLength: "Rafter length (mm)",
    choose: "Choose your roof type",
    chooseUtstick: "Choose roof add ons",
    select: "Select roof",
    selectUtstick: "Select roof add on",
    dims: "Clarify dimensions of your roof",
    input: "Input dimensions for your ",
    cplate: "Choose the type of plating",
    cprod: "Choose one of our products",
    stepSolution: "The solution",
    dcheight: "Desired plate covering height (mm), between ",
    your: "Your ",
    using: "Using ",
    covwidth: "Plate cover width (mm): ",
    covheight: "Plate cover height (mm): ",
    need: "You need in total: ",
    plates: "plates",
    step: "Step ",
    next: "Next Page →",
    prev: "← Previous Page",
    addAddon:"Create roof add on",
    deleteAddon:"Delete this add-on",
    summary: "Summary",
    nobb: "NOBB-number",
    prodn: "Product name",
    numb: "Number",
    price: "Price",
    total: "Sum",
    def: "Default",
    print: "Print product list",
    // Measurements
    length: "Length (mm)",
    width: "Width (mm)",
    height: "Height (mm)",
    widthf: "Width of first part (mm)",
    widths: "Width of second part (mm)",
    heightf: "Height of first part (mm)",
    anglef: "Angle of first part (deg)",
    heights: "Height of second part (mm)",
    angles: "Angle of second part (deg)",
    heightl: "Height of lower part (mm)",
    anglel: "Angle of lower part (deg)",
    heightu: "Height of upper part (mm)",
    angleu: "Angle of upper part (deg)",
    angle: "Roof angle (deg)",
    lend: "Length of end (mm)",
    lendupper: "Length of end upper part (mm)",
    lattach: "Length of attachment part (mm)",
    hend: "Height of end (mm)",
    wend: "Width of end (mm)",
    ilength: "Inner length (mm)",
    iwidth: "Inner width (mm)",
    repetitions: "Number of repetitions of the roof pattern",
    // Roof names
    rDutch: "Dutch gable roof",
    rdDutch: "On a dutch gable roof all sides are slanting, but the short ends not to the top.",
    rTilted: "Tilted roof",
    rdTilted: "A flat roof with a slope.",
    rFlat: "Flat roof",
    rdFlat: "A completely flat roof.",
    rGambel: "Gambrel roof",
    rdGambel: "A gambrel roof is a symmetric roof with two different roof angles on each side.",
    rFlatTopGambel: "Half sided mansard roof",
    rdFlatTopGambel: "A mansard roof with a bare lower short side.",
    rHalf: "Half hipped roof",
    rdHalf: "A halfhipped roof is a gable roof with triangles added at the ends.",
    rHipped: "Hipped roof",
    rdHipped: "A hipped roof has four sides, two of them triangular.",
    rMansard: "Mansard roof",
    rdMansard: "A roof with a rectangular flat top and four sloping sides",
    rPyramid: "Pyramid roof",
    rdPyramid: "A pyamid roof has four sides, all slanting into a point in the center of the roof.",
    rGable: "Gable roof",
    rdGable: "A gable roof with two sides of equal size, slanting into the middle.",
    rSawtooth: "Sawtooth roof",
    rdSawtooth: "A sawtooth roof with multiple angled flat roofs repeated after one another.",
    // Utstick names
    uFlat: "Flat add-on",
    udFlat: "A flat roof add on either with or without a slope.",
    uGable: "Gable add-on",
    udGable: "A roof add on of gable type with two sides of equal size, slanting into the middle.",
    uHalf: "Half hipped",
    udHalf: "A roof add on of half hipped type is a gable utstick with a triangle added at the end.",
    // Error descriptions
    errAngleUpperLim: "Angle must be smaller or equal to 90 degrees",
    errUpperLim: "Number to large, please input a number smaller than ",
    errLowerLim: "Number to small, please input a number larger than ",
    errNotANumber: "Please input a number",
    errFixErrors: "Please fix all errors before proceeding",

    errWidthEnd: "Must be smaller than the width",
    errLengthEnd: "Must be smaller than length/2",
    errDontFit: "Measure does not fit within roof",
    errLengthEndUtstick: "Must be smaller than length",
    errHeighEnd: "Must be smaller than the height",
    errDidNotValidate:"The field has an not valid value",
    // Login information
    loginInfo: "If you are an existing customer and would like to see prices - please login.",
    loginLabel: "Login",
    logoutLabel: "Logout",
    loginUsername: "Username",
    loginPassword: "Password",
    cancel: "Cancel",
    // Late additions:
    incl: "Include add-on",
    product: "Product family",
    platetype: "Plate type",
    surface: "Surface treatment",
    start: "Restart",
    pdf: "Email PDF",
    excel: "Email sheet",
    // title
    title: "Roof calculator",
    titledesc: "Use our modern tool in order to plan the required amount of materials for your roof. By optimizing the placement and how to split the pieces you may both save material and be sure not to transport more than you need to.",
    rabatt:"Discount",
    transport: "* Shipping cost not included",
    "language-en": "English",
    "language-no": "Norwegian",
    "language-se": "Swedish",
    "pickNumb": "Pick amount",
    "recommendedNumb": "Recommended amount",
    "pickProductOptions": "Choose addons",
    // parts of the results table

    c_plates: "Plates",
    c_pipes: "Gutters",
    c_fittings: "Fittings",
    c_extras: "Extras",
    totalprice: "Total price",
    pickSurfaceTreatment: "Pick surface treatment",
    pickPlateThickness: "Pick plate thickness",
    pickColor: "Pick color",
    spacefoot: 'Space from foot of roof (mm)',
    emailFormLoadingLabel: 'Loading',
    emailFormSuccessLabel: 'Email sent - thank you!',
    emailFormErrorTitle: 'Something went wrong',
    emailFormFormTitle: 'Please provide your name and email adress, and you will receive the document in your inbox shortly.',
    emailFormNameLabel: 'Your name',
    emailFormEmailLabel: 'Your email',
    emailFormButtonLabel: 'Send',
    emailFormOptinLabel: 'Tata Steel may send future product information and material. We will not share your email with any third party.',

    totalArea: 'Total'
  }
var se = clone(en);
var no = clone(en);

// Do localization here
se.rafterEmptyWidth =  "En värdi behövs for 'Brädd (mm)'";
se.rafterLength =  "Sparrelängd (mm)"
se.choose = "Välj din taktyp"
se.chooseUtstick = "Välj takkupa"
se.select = "Välj tak"
se.selectUtstick = "Välj utstick"
se.dims = "Beskriv takets dimensioner"
se.input = "Ange dimensionerna för ditt "
se.cplate = "Välj typ av takplatta"
se.cprod = "Välj en av våra produkter"
se.stepSolution = "Resultat",
se.your = "Ditt "
se.using = "Använder "
se.covwidth = "Plattans täckbredd (mm) = "
se.covheight = "Plattans täckhöjd (mm) = "
se.need = "Du behöver totalt = "
se.pickSurfaceTreatment = "Välj utskikt"
se.pickPlateThickness = "Välj plåttjocklek"
se.pickColor = "Välj färg"
se.plates = "plattor"
se.step = "Steg "
se.next = "Nästa steg →"
se.prev = "← Förra steget"
se.deleteAddon ="Ta bort detta utstick"
se.addAddon ="Skapa utstick"
se.summary = "Sammanfattning"
se.nobb = "FINFO"
se.prodn = "Produktnamn"
se.numb = "Antal"
se.price = "Pris"
se.total = "Summa"
se.def = "Standard"
se.print = "Skriv ut"
se.length = "Längd (mm)"
se.height = "Höjd (mm)"
se.width = "Bredd (mm)"
se.widthf = "Bredd av första delen (mm)"
se.widths = "Bredd av andra delen (mm)"
se.heights = "Höjd andra delen (mm)"
se.angles = "Vinkel andra delen (grader)"
se.heightf = "Höjd första delen (mm)"
se.anglef = "Vinkel första delen (grader)"
se.heightl = "Höjd lägre delen (mm)"
se.anglel = "Vinkel lägre delen (grader)"
se.angle = "Takvinkel (grader)"
se.heightu = "Höjd för övre delen (mm)"
se.angleu = "Vinkel övre delen (grader)"
se.lendupper = "Längd övre slut (mm)"
se.lend = "Längd av slutet (mm)"
se.lattach = "Längd av tilllägget (mm)"
se.hend = "Höjd på slutet (mm)"
se.ilength = "Inre längd (mm)"
se.wend = "Bredd av slutet (mm)"
se.iwidth = "Inre bredd (mm)"
se.repetitions = "Antal toppar"
se.rDutch = "Nedsänkt valmtak"
se.rdDutch = "På ett nedsänkt valmtak sluttar alla sidor men kortsidorna inte hela vägen."
se.rTilted = "Pulpettak"
se.rdTilted = "Ett platt tak med vinkel."
se.rFlat = "Platt tak"
se.rdFlat = "Ett helt platt tak."
se.rGambel = "Mansardtak"
se.rdGambel = "Ett mansardtak är symmetriskt med två vinklar på var sida."
se.rFlatTopGambel = "Öppet mansardtak"
se.rdFlatTopGambel = "Mansardtak med öppen ände."
se.rHalf = "Halvvalmtak"
se.rdHalf = "Ett valmtak där sidorna inte går hela vägen ner."
se.rHipped = "Valmtak"
se.rdHipped = "Ett valmtak har fyra sidor två av dem triangulära."
se.rMansard = "Helvalmat tak"
se.rdMansard = "Ett tak med platt topp och fyra sluttande."
se.rPyramid = "Pyramidtak"
se.rdPyramid = "Ett pyramidtak har fyra sluttande sidor."
se.rGable = "Sadeltak"
se.rdGable = "Ett sadeltak har två lika stora sidor."
se.rSawtooth = "Sågtak"
se.rdSawtooth = "Ett sågtak har flera lika toppar."
se.uFlat = "Pulpetkupa"
se.uGable = "Sadeltakskupa"
se.udFlat = "Ett platt utstick med eller utan vinkel."
se.udGable = "Ett sadelutstick har två lika stora sidor."
se.uHalf = "Halvvalmskupa"
se.udHalf = "Ett utstick som ser ut som ett halvt halvvalmstak"
se.errAngleUpperLim = "Vinkeln måste vara mindre än 90 grader."
se.errUpperLim = "Talet är för stort, det måste vara mindre än "
se.errLowerLim = "Talet är för litet, det måste vara större än "
se.errNotANumber = "Vänligen fyll i ett tal"
se.errFixErrors = "Vänligen åtgärda alla fel innan du fortsätter"
se.errWidthEnd = "Måste vara mindre än bredden",
se.errLengthEnd = "Måste vara mindre än längd/2",
se.errDontFit = "Måttet är för stort och får ej plats inom taket",
se.errLengthEndUtstick = "Måste vara mindre än längden",
se.errHeighEnd = "Måste vara mindre än höjden",
se.loginInfo = "Om du är en befintlig kund och vill se priser, logga in, alternativt ring​ +46 3516 1200."
se.loginLabel =  "Logga in",
se.logoutLabel = "Logga ut",
se.loginUser = "användare"
se.loginAdded = "utfört"
se.loginUsername = "Användarnamn"
se.loginPassword = "Lösenord"
se.incl = "Välj takkupa"
se.product = "Produktfamilj"
se.platetype = "Plattyp"
se.surface = "Ytbehandling"
se.start = "Starta om"
se.pdf = "Skicka PDF"
se.title = "Takberäkning",
se.titledesc = "Använd vårt moderna verktyg för att planera hur mycket material som behövs för ditt tak. Genom att optimera placeringarna så slipper du transportera mer material än nödvändigt och du vet hur mycket du behöver."
se.rabatt = "Rabatt"
se.transport = "* Fraktkostnad ingår inte i erbjudandet"
se.excel =  "Skicka Excel dokument"
se.c_plates= "Takplattor"
se.c_pipe= "Hängrännor"
se.c_fittings= "Beslag"
se.c_extras= "Tillbehör"
se.totalprice= "Totalt pris"

se.emailFormLoadingLabel = 'Sender filer',
se.emailFormSuccessLabel = 'E-post sendt - takk!',
se.emailFormErrorTitle = 'Noe gikk galt med sending',
se.emailFormFormTitle = 'Vennligst fyll inn navn og e-post adresse, og du vil straks motta dokumentene i din innboks.',
se.emailFormNameLabel = 'Ditt navn',
se.emailFormEmailLabel = 'Din e-post',
se.emailFormButtonLabel = 'Send',
se.emailFormOptinLabel = 'Tata Steel kan i sende deg produktinformasjon og markedsinformasjon. Vi vil ikke dele din e-post med noen tredjepart.'

se.loginInfo = "Om du är en befintlig kund och vill se priser, logga in, alternativt ring +46 3516 1200."
se.loginLabel = "Logga in"
se.logoutLabel = "Logga ut"
se.loginUsername = "Användarnamn"
se.loginPassword = "Lösenord"
se.cancel = "Stänga"

no.loginInfo = "Hvis du er en eksisterende kunde og ønsker å se priser - vennligst logg inn. Alternativt ring +47 35 91 52 00."
no.loginLabel = "Logg inn"
no.logoutLabel = "Logg ut"
no.loginUsername = "Brukernavn"
no.loginPassword = "Passord"
no.cancel = "Avbryt"

se.totalArea = 'Totalt'
no.totalArea = 'Totalt'

// Do localization here
no.rafterEmptyWidth =  "'Bredde (mm)' mangler verdi";
no.rafterWarn = "Verdien må være større enn ";
no.rafterWarnGeneric = "Verdien er for lav";
no.rafterLength =  "Sperrelengde (mm)"
no.choose = "Velg din taktype";
no.chooseUtstick = "Velg dine utstikk";
no.select = "Klikk for å velge type";
no.selectUtstick = "Klikk for å velge type";
no.dims = "Oppgi dimensjoner på tak";
no.input = "Legg inn målene på ditt ";
no.cplate = "Velg platetype";
no.cprod = "Velg produkt";
no.dcheight = "Ønsket overlapp (mm) mellom ";
no.your = "Ditt ";
no.using = "Ved å bruke ",
no.covwidth = "Plate bredde (mm): ";
no.covheight = "Plate høyde (mm): ";
no.need = "Du trenger totalt: ";
no.plates = "plater";
no.step = "Steg ";
no.next = "Neste side →";
no.prev = "← Forrige side";
no.addAddon = "Legg til utstikk";
no.deleteAddon = "Fjern utstikk";
no.summary = "Totalt";
no.nobb = "NOBB";
no.prodn = "Produktnavn";
no.numb = "Antall";
no.price = "Pris";
no.total = "Sum";
no.def = "Standard";
no.print = "Skriv ut";
no.length = "Lengde (mm)";
no.width = "Bredde (mm)";
no.height = "Høyde (mm)";
no.widthf = "Bredde på første del (mm)";
no.widths = "Bredde på andre del (mm)";
no.heightf = "Høyde på første del (mm)";
no.anglef = "Vinkel på første del (grader)";
no.heights = "Høyde på andre del (mm)";
no.angles = "Vinkel på andre del (grader)";
no.heightl = "Høyde på nederste del (mm)";
no.anglel = "Vinkel på nederste del (grader)";
no.heightu = "Høyde på øvre del (mm)";
no.angleu = "Vinkel på øvre del (grader)";
no.angle = "Takvinkel";
no.lend = "Lengde på enden (mm)",
no.lendupper = "Lengden på enden av øvre del (mm)";
no.lattach = "Lengde på tilsluttet del (mm)";
no.hend = "Høyde på enden (mm)";
no.wend = "Bredde på enden (mm)";
no.ilength = "Indre lengde (mm)";
no.iwidth = "Indre bredde (mm)";
no.repetitions = "Antall repetisjoner";
no.rDutch = "Nedsenket Valmtak";
no.rdDutch = "Variant av valmtaket der skråflatene på kortsidene ikke går helt opp til mønet.";
no.rTilted = "Pulttak";
no.rdTilted = "Tak med bare én takflate som har fall til den ene siden av bygningen.";
no.rFlat = "Flatt tak";
no.rdFlat = "Tak med bare én takflate som har fall til den ene siden av bygningen.";
no.rGambel = "Mansardtak";
no.rdGambel = "Hver takside har en markert langsgående knekk som skille mellom en bratt nedre takflate og en slakere øvre takflate.";
no.rFlatTopGambel = "Halvalmet Mansardtak";
no.rdFlatTopGambel = "Variant av valmet mansardtak som svarer til halvvalmtaket. På husets kortsider er det valm bare på den slake øvre delen av mansardtaket.";
no.rHalf = "Halvvalm tak";
no.rdHalf = "Variant av valmtaket der skråflatene på kortsidene ikke går helt ned til loftsgulvet.";
no.rHipped = "Valmtak";
no.rdHipped = "Variant av saltaket. Saltaket strekker seg ikke i hele husets lengde, men møter skrå takflater fra hver av husets kortsider.";
no.rMansard = "Helvalmet Mansardtak";
no.rdMansard = "Alle sider av taket har en markert langsgående knekk som skille mellom en bratt nedre takflate og en slakere øvre takflate.";
no.rPyramid = "Telttak";
no.rdPyramid = "Valmtak over en kvadratisk bygningskropp, der de fire skrå takflatene møtes i en spiss.";
no.rGable = "Saltak";
no.rdGable = "Tak med skrå takflater fra to sider av bygningen som møtes i mønet.";
no.rSawtooth = "Sagtak";
no.rdSawtooth = "Tak som statisk kan ha samme virkemåte som skalltak, men «bølgene» består av vekselvis bratte og mindre bratte flater med fall til motsatt side.";
no.uFlat = "Pulttak utstikk";
no.udFlat = "Utstikk med bare én takflate som har fall til utsiden av bygningen.";
no.uGable = "Saltak utstikk";
no.udGable = "Utstikk med skrå takflater som møtes i mønet.";
no.uHalf = "Halvvalm utstikk";
no.udHalf = "Utstikk der skråflate på kortsiden ikke går helt ned til loftsgulvet.";
no.errAngleUpperLim = "Vinkelen må være mindre eller lik 90 grader";
no.errUpperLim = "Oppgi et mål som er mindre enn ";
no.errLowerLim = "Oppgi et mål som er større enn ";
no.errNotANumber = "Legg inn mål";
no.errFixErrors = "Korriger mål før du fortsetter";
no.errWidthEnd = "Må være smalere enn bredden";
no.errLengthEnd = "Må være kortere enn halvparten av lengden";
no.errDontFit = "Målene passer ikke til taktypen";
no.errLengthEndUtstick = "Må være kortere enn lengden";
no.errHeighEnd = "Må være lavere enn høyden";
no.errDidNotValidate = "Feltet har en ugyldig verdi"
no.incl = "Legg til";
no.product = "Produktgruppe";
no.platetype = "Profil";
no.surface = "Overflate";
no.start = "Nullstill";
no.stepSolution = "Resultater";
no.pdf = "Send PDF"
no.title =  "Takberegning",
no.titledesc =  "Bruk vår takberegningsverktøy til å planlegge hvor mye materiell du trenger for å dekke ditt tak. Gjennom å optimalisere plasseringen så kan du holde svinn til et minimum og du ser nøyaktig hvor mye du trenger."
no.rabatt = "Rabatt";
no.transport = "* Fraktkostnader kommer i tillegg"
no.excel =  "Send Excel dokument"
no.pickNumb = "Velg antall"
no.recommendedNumb = "Anbefalt antall"
no.pickProductOptions = "Velg tilbehør"
no.c_plates= "Takplater"
no.c_pipes= "Takrenner"
no.c_fittings= "Beslag"
no.c_extras= "Tilbehør"
no.totalprice= "Totalpris"
no.pickSurfaceTreatment = "Velg overflatebehandling"
no.pickPlateThickness = "Velg platetykkelse"
no.pickColor = "Velg farge"
no.spacefoot = 'Avstand til takfot (mm)'

no.emailFormLoadingLabel = 'Sender filer',
no.emailFormSuccessLabel = 'E-post sendt - takk!',
no.emailFormErrorTitle = 'Noe gikk galt med sending',
no.emailFormFormTitle = 'Vennligst fyll inn navn og e-post adresse, og du vil straks motta dokumentene i din innboks.',
no.emailFormNameLabel = 'Ditt navn',
no.emailFormEmailLabel = 'Din e-post',
no.emailFormButtonLabel = 'Send',
no.emailFormOptinLabel = 'Tata Steel kan i sende deg produktinformasjon og markedsinformasjon. Vi vil ikke dele din e-post med noen tredjepart.'

module.exports = new LocalizedStrings({
  en: en,
  se: se,
	no: no
});

if(window.lang != undefined) {
  module.exports.setLanguage(window.lang)
}
// Make it accessible globally
window.text = module.exports



// WEBPACK FOOTER //
// ./Text.js